module.exports = __webpack_public_path__ + "9dde1ed8502b4b50bd4a4810c8b7e44f.svg";